import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { AppProvider, useApp } from "./context/AppContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Auth from "./pages/Auth";
import Wishlist, { Account } from "./pages/Wishlist";
import Compare from "./pages/Compare";
import About from "./pages/About";
import Admin from "./pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const { loading, settings } = useApp();
  const isAdmin = pathname.startsWith("/admin");
  if (loading || !settings) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4">
        <div className="brand-font text-3xl tracking-[0.3em] text-neutral-800">{(settings?.brandName || "").toUpperCase()}</div>
        <div className="w-8 h-8 border-2 border-neutral-200 rounded-full animate-spin" style={{ borderTopColor: "var(--brand)" }} />
      </div>
    );
  }
  return (
    <>
      {!isAdmin && <Header />}
      <main key={pathname} className="page-transition">{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingWhatsApp />}
    </>
  );
}

function App() {
  useEffect(() => {
    const h = () => toast.error("Depolama alanı doldu — değişiklik kaydedilemedi. Lütfen büyük videoları kaldırın (mock sınırı) veya backend'e geçin.");
    window.addEventListener("md:save-error", h);
    return () => window.removeEventListener("md:save-error", h);
  }, []);
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:categorySlug" element={<Shop />} />
              <Route path="/shop/:categorySlug/:subSlug" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/account" element={<Account />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/about" element={<About />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </Layout>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
